import { abbreviateNumber, theme } from '@hhgtech/hhg-components'
import { Text } from 'components/atoms/text'
import { useIntl } from 'react-intl'

import { StyledDetailStatistic } from './index.styled'

type DetailStatisticProps = {
  postsCount: number
  membersCount: number
}
export const DetailStatistic = ({
  postsCount,
  membersCount,
}: DetailStatisticProps) => {
  const { formatMessage: f } = useIntl()
  return (
    <StyledDetailStatistic>
      {postsCount >= 1000 && (
        <Text type="bodytext-2" color={theme.mbColors.gray}>
          {abbreviateNumber(postsCount)}{' '}
          {f({
            id: 'embedCommunity.card.posts',
            defaultMessage: 'Posts',
          })}
        </Text>
      )}
      {postsCount >= 1000 && membersCount >= 1000 && (
        <Text type="bodytext-1" color={theme.mbColors.gray}>
          &middot;
        </Text>
      )}
      {membersCount >= 1000 && (
        <Text type="bodytext-2" color={theme.mbColors.gray}>
          {abbreviateNumber(membersCount)}{' '}
          {f({
            id: 'embedCommunity.card.members',
            defaultMessage: 'Members',
          })}
        </Text>
      )}
    </StyledDetailStatistic>
  )
}
